export enum Storage {
	CurrentLanguage = 'current-language',
	ReferenceUser = 'reference-user',
	IntervalCurrencyList = 'interval-currency-list',
	FiltersCurrencyList = 'filters-currency-list',
	SortingCurrencyList = 'sorting-currency-list',
	FiltersNotifications = 'filters-notifications',
	IntervalNotifications = 'interval-notifications',
}
